import React from "react";
import isArray from "lodash/isArray";
import { Popover, Input, Button, Tooltip, Tabs } from "antd";
import { Base64 } from "js-base64";
import WeaTextareaNormal from "../wea-textarea-normal";
import WeaLocaleProvider from "../../wea-locale-provider";
import "./style/index.less";
const TabPane = Tabs.TabPane;
const getLabel = WeaLocaleProvider.getLabel;
const LANG = {
  PREFIX: "~`~`",
  SPLITTER: "`~`",
  SUFFIX: "`~`~"
};

class WeaTextareaLocale extends React.Component {
  static ref = {};

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      resultValue: "",
      value: "",
      list: {},
      currentlanguageid: "7"
    };
  }

  static getList = function(multiStr, cb) {
    if (cb && typeof cb === "function") {
      const list = {};
      if (multiStr.indexOf(LANG.PREFIX) > -1) {
        multiStr = multiStr.substring(4);
        multiStr = multiStr.substring(0, multiStr.length - 4);
        multiStr.split(LANG.SPLITTER).map(item => {
          list[item.substr(0, 2)] = item.substr(2);
        });
      } else {
        return multiStr;
      }
      const resultObj = cb(list);
      const resultArr = Object.keys(resultObj).map(item => {
        return item + resultObj[item];
      });
      return LANG.PREFIX + resultArr.join(LANG.SPLITTER) + LANG.SUFFIX;
    }
    return multiStr;
  };

  static getCurrentLabel = (multiStr, langId) => {
    const localeLanguageId =
      langId || window.localStorage.getItem("languageidweaver") || "7";
    const list = {};
    if (typeof multiStr === "string" && multiStr.indexOf(LANG.PREFIX) > -1) {
      multiStr = multiStr.substring(4);
      multiStr = multiStr.substring(0, multiStr.length - 4);
      multiStr.split(LANG.SPLITTER).map(item => {
        list[item.substr(0, 2).replace(" ", "")] = item.substr(2);
      });
      return list[localeLanguageId] || multiStr;
    } else {
      return multiStr;
    }
  };

  componentDidMount() {
    let activeLanguageIds =
      window.localStorage.getItem("activeLanguageIds") || "['7']";
    try {
      activeLanguageIds = JSON.parse(activeLanguageIds);
    } catch (error) {
      console.error("请检查 localStorage", error);
      activeLanguageIds = ["7"];
    }
    activeLanguageIds = isArray(activeLanguageIds) ? activeLanguageIds : ["7"];
    const list = {};
    activeLanguageIds.forEach((item, index) => {
      list[item] = "";
    });
    this.setState({ list }, () => {
      if (
        this.props.hasOwnProperty("value") &&
        this.props.value !== undefined
      ) {
        this.updatePropsValue(this.props.value, this.props);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    // value 回显处理
    if ("value" in nextProps) {
      // console.log(nextProps.value, " | ", this.props.value)
      const value = nextProps.value || "";
      if (
        nextProps.value !== this.props.value ||
        value.indexOf("base64_") > -1
      ) {
        this.updatePropsValue(nextProps.value, nextProps);
      }
    }
  }

  updatePropsValue = (value, nextProps = {}) => {
    const localeLanguageId = this.getLanguageidweaver();
    const { list } = this.state;
    if (value && nextProps.isBase64 && value.indexOf("base64_") > -1) {
      // remove base64_
      value = Base64.decode(value.substr(7));
      typeof this.props.onChange === "function" && this.props.onChange(value);
      typeof this.props.onBlur === "function" && this.props.onBlur(value);
    }
    // console.log('update props', list, value);
    if (value && value.indexOf(LANG.PREFIX) > -1) {
      // 多值
      value = value.substring(4);
      value = value.substring(0, value.length - 4);
      const tempArray = value.split(LANG.SPLITTER);
      // console.log(this.props.value)
      // console.log("list", list);
      const tempArrayKeys = [];
      tempArray.forEach(item => {
        let key = item.substr(0, 2).replace(/\s/g, "");
        tempArrayKeys.push(key);
        let value = item.replace(/^\S*?\s/, "");
        // console.log("73", list, key);
        if (list.hasOwnProperty(key)) {
          // 值在 active langeuage里面，就更新
          list[key] = value;
        }
        if (localeLanguageId == key) {
          // console.log(tempArray, key, value)
          this.setState({ value });
        }
      });

      Object.keys(list).forEach(item => {
        if (!tempArrayKeys.includes(item)) {
          list[item] = "";
        }
      });
      // console.log(list);
    } else {
      // 单值
      Object.keys(list).forEach(item => {
        list[item] = "";
      });
      list[localeLanguageId] = value;
      this.setState({ value });
    }
    const resultValue = this.getResultValue(list, localeLanguageId);
    this.setState({ resultValue });
  };

  getLanguageidweaver = () => {
    let localeLanguageId =
      window.localStorage.getItem("languageidweaver") ||
      this.state.currentlanguageid;
    if (isNaN(Number(localeLanguageId))) {
      localeLanguageId = this.state.currentlanguageid;
    }
    return localeLanguageId;
  };

  getResultValue = (list, id) => {
    let resultValue = "";
    const temp = [];
    Object.keys(list)
      .reverse()
      .forEach(id => {
        this.setState({ value: list[id] });
        if (list[id] !== "") {
          temp.push(`${id} ${list[id]}`);
        }
      });
    // console.log('temp', temp, 'list', list, 'id', id);
    if (temp.length === 1) {
      resultValue = temp.toString().substr(2);
    } else if (temp.length === 0) {
      resultValue = "";
    } else {
      resultValue =
        LANG.PREFIX + temp.reverse().join(LANG.SPLITTER) + LANG.SUFFIX;
    }
    // customSUFFIX = "1"
    return resultValue.replace(/\u200B/g, "");
  };

  addMultiLang = (e, id) => {
    const localeLanguageId = this.getLanguageidweaver();
    const { list } = this.state;
    if (e.target) {
      list[id] = e.target.value;
    } else {
      list[id] = e;
    }
    const resultValue = this.getResultValue(list, id);
    this.props.onChange && this.props.onChange(resultValue);
    this.props.onBlur && this.props.onBlur(resultValue);
    // console.log(list, resultValue);
    this.setState({ value: list[localeLanguageId], resultValue });
  };

  confirm = () => {
    this.setState({
      visible: false
    });
    // console.log('pass resultvalue to onblur', this.state.resultValue, this.state);
    typeof this.props.onBlur === "function" &&
      this.props.onBlur(this.state.resultValue);
    typeof this.props.onChange === "function" &&
      this.props.onChange(this.state.resultValue);
  };

  cancel = () => {
    this.setState({
      visible: false
    });
  };

  toggleClick = e => {
    const { visible } = this.state;
    e.stopPropagation();
    this.setState({
      visible: !visible
    });
  };

  changeChoosen = item => {
    this.setState({
      currentlanguageid: item
    });
  };

  focus = () => {
    this.refs.textareaNormal &&
      this.refs.textareaNormal.focus &&
      this.refs.textareaNormal.focus();
  };

  render() {
    const {
      props,
      props: { className = "", style, overlayClassName = "" }
    } = this;
    const { list, value, resultValue, currentlanguageid } = this.state;
    const localeLanguageId = this.getLanguageidweaver();
    const titleTabs = Object.keys(list).map((item, index) => {
      return (
        <TabPane
          tab={
            <div
              onClick={e => this.changeChoosen(item)}
              className={`wea-textarea-popover-title-img ${
                currentlanguageid === item ? "choosen" : ""
              }`}
            >
              <img
                src={`/images/ecology9/multiLang/multilang_${item}.png`}
                alt=""
              />
            </div>
          }
          key={index}
        />
      );
    });
    const titleTab = (
      <div>
        <Tabs className="wea-textarea-popover-title" defaultActiveKey="1">
          {titleTabs}
        </Tabs>
      </div>
    );
    const content = (
      <div>
        <WeaTextareaNormal
          {...props}
          noResize
          minRows={4}
          maxRows={4}
          onChange={e => this.addMultiLang(e, currentlanguageid.toString())}
          defaultValue={list[currentlanguageid]}
          value={list[currentlanguageid]}
          onBlur={e => {}}
        />
        <hr
          style={{ marginTop: 10, marginBottom: 10, border: "1px solid #eee" }}
        />
        <div className="wea-input-locale-popover-button-group">
          <Button
            style={{ marginRight: 10 }}
            onClick={this.confirm}
            type="primary"
          >
            {getLabel("826", "确定")}
          </Button>
          <Button onClick={this.cancel}>{getLabel("31129", "取消")}</Button>
        </div>
      </div>
    );
    return (
      <div className={className} style={style}>
        <div className="wea-text-area-locale-container">
          <WeaTextareaNormal
            {...props}
            ref="textareaNormal"
            noResize
            minRows={4}
            maxRows={4}
            onChange={e => this.addMultiLang(e, localeLanguageId.toString())}
            defaultValue={list[localeLanguageId]}
            value={list[localeLanguageId]}
            onBlur={e => {}}
          />
          <div
            ref={ref => (this.ref = ref)}
            className={`wea-text-area-locale`}
            onClick={e => this.toggleClick(e)}
          >
            <Popover
              overlayClassName={`wea-textarea-popover ${overlayClassName}`}
              visible={this.state.visible}
              trigger="click"
              placement="bottom"
              title={titleTab}
              content={content}
              overlayStyle={{
                width:
                  this.ref &&
                  (this.ref.clientWidth < 163 ? 163 : this.ref.clientWidth)
                // left: 0, top: 30,
              }}
            >
              <div>
                {resultValue && resultValue.indexOf(LANG.PREFIX) > -1 ? (
                  <div class="wea-text-area-locale-earth-icon">
                    <Tooltip
                      placement="right"
                      title={getLabel("385819", "已设置多语言")}
                    >
                      <img
                        src="/images/ecology9/multiLang/seted-multi-lang.png"
                        alt=""
                      />
                    </Tooltip>
                  </div>
                ) : (
                  <div class="wea-text-area-locale-earth-icon">
                    <Tooltip
                      placement="right"
                      title={getLabel("385828", "未设置多语言")}
                    >
                      <img
                        src="/images/ecology9/multiLang/unset-multi-lang.png"
                        alt=""
                      />
                    </Tooltip>
                  </div>
                )}
              </div>
            </Popover>
          </div>
        </div>
      </div>
    );
  }
}

export default WeaTextareaLocale;



// WEBPACK FOOTER //
// ./ecology9/base/wea-textarea-locale/index.js